import { recordAgent247EventSeenApi } from "./api";
import {
  formatAgentAlbertAlertSeenBy,
  formatAgentAlbertAlertSeenByTitle,
} from "./agentAlbertAlertReadState";

export { formatAgentAlbertAlertSeenBy as formatAiAssistantSeenBy };
export { formatAgentAlbertAlertSeenByTitle as formatAiAssistantSeenByTitle };

const storageKey = (organizationId) =>
  `aiAssistantSeenEvents:${String(organizationId || "").trim()}`;

export const getStableEventId = (event) => {
  const mongoId = String(event?._id || "").trim();
  if (mongoId) return mongoId;
  const callId = String(event?.callId || "").trim();
  const ts = String(event?.timestamp || event?.createdAt || "").trim();
  if (callId && ts) return `legacy:${callId}:${ts}`;
  return "";
};

export const getSeenEventIds = (organizationId) => {
  if (!organizationId) return new Set();
  try {
    const raw = localStorage.getItem(storageKey(organizationId));
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.map(String));
  } catch {
    return new Set();
  }
};

const getCurrentUserSnapshot = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const getCurrentUserId = () => {
  const user = getCurrentUserSnapshot();
  return String(user?.id || user?._id || "").trim();
};

const upsertLocalSeenBy = (event, user) => {
  const userId = String(user?.id || user?._id || "").trim();
  const userName = String(user?.name || "").trim() || "User";
  const userEmail = String(user?.email || "").trim();
  if (!userId) return event;

  const existing = Array.isArray(event?.seenBy) ? event.seenBy : [];
  const filtered = existing.filter((row) => String(row?.userId) !== userId);
  return {
    ...event,
    seenBy: [
      {
        userId,
        userName,
        userEmail,
        seenAt: new Date().toISOString(),
      },
      ...filtered,
    ],
  };
};

export const markAiAssistantEventSeen = (organizationId, event) => {
  const id = getStableEventId(event);
  if (!organizationId || !id) return event;

  const set = getSeenEventIds(organizationId);
  if (!set.has(id)) {
    set.add(id);
    try {
      localStorage.setItem(storageKey(organizationId), JSON.stringify([...set]));
    } catch {
      /* ignore quota errors */
    }
  }

  const user = getCurrentUserSnapshot();
  if (user) {
    recordAgent247EventSeenApi({
      organizationId,
      eventId: id,
    }).catch((err) => {
      console.warn("[24/7 Inquiry Call Assist] Failed to save seen-by on server", err);
    });
  }

  window.dispatchEvent(
    new CustomEvent("aiAssistantSeenUpdated", {
      detail: { organizationId: String(organizationId), eventId: id },
    }),
  );

  return user ? upsertLocalSeenBy(event, user) : event;
};

export const countUnreadAiAssistantEvents = (events, organizationId) => {
  if (!organizationId || !Array.isArray(events)) return 0;
  const seen = getSeenEventIds(organizationId);
  const currentUserId = getCurrentUserId();
  return events.filter((e) => {
    const id = getStableEventId(e);
    if (!id || seen.has(id)) return false;
    if (!currentUserId) return true;
    const seenByCurrentUser = Array.isArray(e?.seenBy)
      ? e.seenBy.some(
          (row) => String(row?.userId || "").trim() === currentUserId,
        )
      : false;
    return !seenByCurrentUser;
  }).length;
};
